@import 'styles/mixins';
@import 'styles/variables';

.aiRevision {
  background: var(--focus-10);
}
